import React from 'react';

export default class YouTubeVideo extends React.Component{
    render() {
      return (
        
            <iframe 
              width="100%" 
              height="250px" 
              src={`https://www.youtube.com/embed/${this.props.embedId}`} 
              title="YouTube video player" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen>
            </iframe>
        
      );
    }
  }